import { useFlag, useFlags } from '@unleash/proxy-client-react'

const INTEGRATION_FEATURE_TOGGLES = [
  'zendeskIntegration',
  'gmailIntegration',
  'gsheetsIntegration',
  'stripeIntegration',
  'mailchimpIntegration',
  'makeDotComIntegration',
  'googleCalendarIntegration',
  'dalleIntegration',
  'chat-api',
  'discordIntegration',
  'githubIntegration',
  'openaiIntegration',
  'groqIntegration',
  'claudeIntegration',
  'dashboard-hitl',
  'anthropicIntegration',
  'fireworksAiIntegration',
  'cerebrasIntegration',
] as const

export type IntegrationFeatureToggle = (typeof INTEGRATION_FEATURE_TOGGLES)[number]

export type FeatureToggle =
  | 'hitlWhitelist'
  | 'bot-deployment-environments'
  | 'webchatV2'
  | 'chat-api'
  | 'slackNewForm'
  | 'alwaysAlive'
  | 'usageBannerNotifications'
  | 'integrations.publish'
  | 'integrations.selfhosted'
  | 'dashboard-onboarding'
  | 'dashboard-onboarding-experiment'
  | 'dashboard-post-signup-fork'
  | 'dashboardFileUpload'
  | 'webchat-instead-of-intercom'
  | 'billing-yearly-plans'
  | 'new-bot-onboarding'
  | 'webchat-admin-key'
  | 'should-record-session'
  | 'workflow-page'
  | 'pushpin-upgrade'
  | 'adk-bots-from-dashboard'

export function useFeature(featureName: FeatureToggle) {
  return useFlag(featureName)
}

export function useAllFeatures() {
  return useFlags()
}
